import React, { useState, useEffect } from 'react';
import { Route, Switch } from 'react-router-dom';

import App from './components/App/App';
import ProjectsRoute from './components/ProjectsRoute';
// import Loading from './components/UI/Loading/Loading';

const Routes = () => {
    const [loaded, setLoaded] = useState(false);

    useEffect(()=> {
      const setLoadHandler = ()=> setLoaded(true);
      window.addEventListener('load', setLoadHandler);
  
      return ()=> {
        window.removeEventListener('load', setLoadHandler)
      }
    }, []);

    return (
        <>
            <Switch>

                <Route path="/projects" component={ProjectsRoute} />
                <Route path="/" exact render={props => <App {...props} loaded={loaded} />}  />

            </Switch>
        </>
    )
}

export default Routes
